<highcharts-chart
  [Highcharts]="highcharts"
  [options]="chartOptions"
  style="width: 100%; height: 90%; display: block"
>
</highcharts-chart>
